module.exports = __webpack_public_path__ + "img/20@2x.76506f74.png";